<template>
	<div>
		<div
			ref="modal"
			class="modal fade"
			:class="{ show, 'd-block': active }"
			tabindex="-1"
			role="dialog"
		>
			<div
				class="modal-dialog modal-dialog-slideup"
				:class="size ?? null"
				role="document"
			>
				<div class="modal-content">
					<div class="block block-rounded shadow-none mb-0">
						<div class="block-header block-header-default">
							<h3 class="block-title">
								<slot name="title"></slot>
							</h3>
							<div v-if="!hide_close" class="block-options">
								<button id="btn_block_option"
									@click="toggleModal"
									type="button"
									class="btn-block-option"
									aria-label="Close"
								>
									<i class="fa fa-times"></i>
								</button>
							</div>
						</div>
						<slot name="banner"></slot>
						<div class="block-content fs-sm">
							<slot name="body"></slot>
						</div>
						<div
							v-if="!!$slots.footer"
							class="block-content block-content-full block-content-sm text-end border-top space-x-1"
						>
							<slot name="footer"></slot>
						</div>
					</div>
				</div>
			</div>
		</div>
		<teleport to="body">
			<div v-if="active" class="modal-backdrop fade show"></div>
		</teleport>
	</div>
</template>
<script>
import { ref } from 'vue'

export default {
	props: {
		size: String,
		hide_close: Boolean,
	},
	setup() {
		const active 	= ref(false)

		const show 		= ref(false)
		const has_video = ref(false)

		const toggleModal = (_has_video) => {
			const body = document.querySelector('body')

			has_video.value = _has_video;

			active.value = !active.value;

			if (active.value) {
				body.style.overflow = 'hidden'
				body.classList.add('modal-open')
			} else {
				body.style.overflow = null
				body.classList.remove('modal-open')

				if(has_video.value)
				{
					var src = $("iframe").attr("src");
					$("iframe").attr("src","");
					$("iframe").attr("src",src);
					has_video.value = false
				}
			}

			setTimeout(() => (show.value = !show.value), 10)
		}

		return {
			active,
			has_video,
			show,
			toggleModal,
		}
	},
}
</script>
